import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'player-track-next',
  'IconPlayerTrackNext',
  [
    ['path', { d: 'M3 5v14l8 -7z', key: 'svg-0' }],
    ['path', { d: 'M14 5v14l8 -7z', key: 'svg-1' }],
  ],
);
